import React from 'react'
import { Box } from '@mui/material'
import { pointText, batsuText } from '../../../lib/rule'

const Lose = ({ simple, rule, label }) => {
  const [pt, bt] = [pointText(simple), batsuText(simple)]

  const point = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {pt}
      </Box>
    </>
  )

  const batsu = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {bt}
      </Box>
    </>
  )

  const above = value => (
    <Box component="span" className="rule-above">
      {value ? '以上' : '以下'}
    </Box>
  )

  const list = [(
    rule.losePoint.active &&
    <Box component="span" className="rule-content" key="lose-point">
      {point(rule.losePoint.value)}{above(rule.losePoint.above)}
    </Box>
  ), (
    rule.loseBatsu.active &&
    <Box component="span" className="rule-content" key="lose-batsu">
      {batsu(rule.loseBatsu.value)}{above(rule.loseBatsu.above)}
    </Box>
  )].filter(e => e)

  return list.length > 0 && (
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">{label || '失格'}</Box>
      {list}
    </Box>
  )
}

export default Lose
